import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {

  
  connectedCallback() {
    super.connectedCallback();
  
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd, true);
    document.addEventListener('cart:updated', this.#handleCartUpdate, true);
    document.addEventListener('cart:update', this.#handleCartUpdate, true);
  
    // Close buttons
    this.addEventListener('click', (e) => {
      const closeBtn = e.target.closest('[data-cart-close]');
      if (!closeBtn) return;
  
      e.preventDefault();
      e.stopPropagation();
      this.close();
    });
  }
  

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd, true);
    document.removeEventListener('cart:update', this.#handleCartUpdate, true);
  }

  #handleCartAdd = (event) => {
    console.log('[cart-drawer] CartAddEvent received:', event.detail?.data);
    
    // Check if auto-open is enabled OR if source is product-holistic, product-holistic-bundle, quick-add-button, cart-recommendations, or product-form
    // For product detail page, listing pages (quick-add), and cart recommendations, always open the drawer
    const hasAutoOpen = this.hasAttribute('auto-open');
    const source = event.detail?.data?.source || 'unknown';
    const isProductDetailPage = source === 'product-holistic' || source === 'product-holistic-bundle' || source === 'product-form';
    const isListingPage = source === 'quick-add-button';
    const isCartRecommendation = source === 'cart-recommendations';
    
    console.log('[cart-drawer] Source check - hasAutoOpen:', hasAutoOpen, 'isProductDetailPage:', isProductDetailPage, 'isListingPage:', isListingPage, 'isCartRecommendation:', isCartRecommendation, 'source:', source);
    
    if (!hasAutoOpen && !isProductDetailPage && !isListingPage && !isCartRecommendation) {
      console.log('[cart-drawer] Auto-open not enabled and not recognized source, skipping drawer open');
      return;
    }
    
    // Prevent duplicate opens
    const dialog = this.querySelector('.cart-drawer__dialog');
    if (dialog?.open || this.hasAttribute('data-opening')) {
      console.log('[cart-drawer] Drawer already open or opening, skipping');
      return;
    }
    
    this.setAttribute('data-opening', 'true');
    
    // Wait for DOM + paint, then open
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.open();
        this.removeAttribute('data-opening');
      });
    });
  };
  
  #handleCartUpdate = (event) => {
    const dialog = this.querySelector('.cart-drawer__dialog');
  
    // Prevent duplicate opens - if already open or opening, skip
    if (dialog?.open || this.hasAttribute('data-opening')) {
      return;
    }
    
    // Only open if source is cart-recommendations (for adding from recommendations)
    // Otherwise, let #handleCartAdd handle the opening
    const source = event.detail?.data?.source || 'unknown';
    if (source !== 'cart-recommendations') {
      return;
    }
  
    this.setAttribute('data-opening', 'true');
  
    // Wait for DOM + paint
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.open();
        this.removeAttribute('data-opening');
      });
    });
  };
  
  

  open() {
    const dialog = this.querySelector('.cart-drawer__dialog');
    if (!dialog) {
      console.warn('[cart-drawer] Dialog element not found');
      return;
    }
    
    // Double-check if already open to prevent duplicate opens
    if (dialog.hasAttribute('open') || dialog.open) {
      console.log('[cart-drawer] Dialog already open, skipping');
      return;
    }
    
    this.showDialog();
  }
  

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
